import { Loader } from "./Loader";
import { ImageResource } from "./ImageResource";
import { Effect } from "./Effect";
import { Material } from "./Material";
import { Geometry } from "./Geometry";
import { Controller } from "./Controller";
import { Scene } from "./Scene";
import { Animation } from "./Animation";
import { AnimationState } from "./AnimationState";
import { AnimationClip } from "./AnimationClip";

export class ObjectContainer {

    public reference: string;

    public imageLibrary: ImageResource[];
    public effectLibrary: Effect[];
    public materialLibrary: Material[];
    public geometryLibrary: Geometry[];
    public controllerLibrary: Controller[];
    public sceneLibrary: Scene[];
    public animationLibrary: Animation[];
    public animationStateLibrary: AnimationState[];
    public animationClipLibrary: AnimationClip[];

    public loadBlob(dataView: DataView, loader: Loader) {
        let offset = 0;

        let strResult = loader.util.readString(dataView, offset);
        this.reference = strResult.string;
        offset = strResult.offset;

        let libraryNames = ['image', 'effect', 'material', 'geometry', 'controller', 'scene', 'animation', 'animationState', 'animationClip'];

        for (let libName of libraryNames) {
            let listResult = loader.util.readIdentityList(dataView, offset);
            this[libName + 'Library'] = listResult.items;
            offset = listResult.offset;
        }

        loader.colladaObjects[this.reference] = this;
    }

}
